export const getFormattedPrice = (itemPrice) => {
    return `$${(itemPrice / 100).toFixed(2)}`;
}